import styles from "./custom-label.module.css";

const Label = ({ text }) => {
  return text ? <div className={styles.label}>{text}:</div> : null;
};

export default Label;
